// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1UUoX","main":"Header_main__3N8Gx","loadingBar":"Header_loadingBar__1o2p2"};